import type {ConnectElementConfig} from '../ConnectElementList';

export const InvoiceHistoryConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "invoiceHistory" */
      '../../../components/Billing/InvoiceHistory'
    ),
  teamOwner: 'billing-ux-platform',
  sentryTeam: 'billing_ux_platform',
  releaseState: 'internal',
  description: 'Displays the Invoice History for Billing Customers',
  friendlyName: 'Billing Invoice History',
};
